import PropTypes from "prop-types"
import React from "react"
import { Link, useStaticQuery } from "gatsby"

import "../css/learn-info.css"

import { HandleImages } from "../components/functions"
import Img from "gatsby-image"
import bike from "../images/bike.webm"
import door from "../images/door.webm"
import OnVisible from "react-on-visible"

import pAIcon from "../images/project-ares-logo.svg"


const style = {}
var height
var position

class LearnInfo extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      visible: true,
      active:true
    }
  
  }

  
  componentDidMount() {
      var current=this;
    console.log('mount',this.state.active);
    this.setState({
      safari:!!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/)
  })
   /* setInterval(function() {
        current.setState({
          active: !current.state.active
        });
      }, 5000)*/
  }


 
  render() {
     
    return (
      <div className="learn-info-wrapper">
        <div className="top">
          <div className="left">
            {" "}
            <div>
              <div>
              
                <p>Learning cyber security doesn’t have to be intimidating, drawn out, or costly. In fact, we believe learning cyber security should be <span>FUN</span>, <span>AFFORDABLE</span>, and <span>ACCESSIBLE</span> to all. </p>
              </div>
              <OnVisible className="video-wrapper">
              {this.state.safari?<HandleImages name="bike"/>:        <video autoplay="true" loop="true" muted="true">
<source src={bike} type="video/webm" />
</video>}



              </OnVisible>
            </div>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1109.4 159.9">
              <path
                fill="#f5f5f5"
                d="M1065.5 72.1l8.8 10.6 35.1-27-75.4-21.5 7.2 8.7H200.5L196.1 19h22.1L170.5 0l-47.7 19h22.1l-4.5 23.9H68.2l7.2-8.7L0 55.7l35.1 27 8.8-10.6h91l-8.2 43.9H98.4l72.1 43.9 72.1-43.9h-28.4L206 72.1z"
              />
            </svg>
          </div>

          <div className="right">
            <div>
              <h3>Practice Makes Perfect!</h3>
              <p>Get hands-on experience inside Project Ares.</p>
            </div>
          </div>
        </div>

        <div className="bottom">
          <div className="left">
            <div>
              <h3>There's a world of opportunity in the cyber field.</h3>
              <p>
                ISC<sup>2</sup> estimates that over{" "}
                <span>4 million cyber professionals will be needed</span> to
                fill the widening industry skills gap.
              </p>

              <p>
                You can be one of the energetic, skilled professionals that
                employers are searching for!
              </p>
            </div>
            <OnVisible className="video-wrapper" >
              {this.state.visible && (
                <video autoplay="true" muted="true">
                  <source src={door} type="video/webm" />
                </video>
              )}
            </OnVisible>
          </div>
          <div className="right">
            <div>
              <h3>
                <span>Learning + Fun</span> is education at its best
              </h3>
            </div>{" "}
            <HandleImages name="youngPeople" />
          </div>
        </div>
        <div  className={this.state.active?'active white':"white"}  >
        <OnVisible  >
<div className="icon">

<svg id="bg" viewBox="-100 -100 200 200"  
   >
 
 
<path class="st0" d="M30.9,-39.5C34.4,-34,27.5,-18.8,28.4,-6.1C29.4,6.6,38.1,16.8,36.3,22C34.6,27.3,22.3,27.5,9.9,35.7C-2.5,43.9,-15.1,60.1,-20.3,57.5C-25.5,54.9,-23.2,33.5,-24.5,19.7C-25.8,6,-30.6,-0.1,-36.6,-13.5C-42.6,-26.8,-49.8,-47.3,-43.9,-52.4C-38,-57.5,-19,-47.1,-2.6,-44C13.7,-40.9,27.5,-45,30.9,-39.5Z"/>
</svg>
<svg  className="control" viewBox="0 0 134.2 84.3" >
 
 
<g>
    <path class="st0" d="M131.2,55.7c-8-29-11.2-54.2-32.1-54.2H35.1C14.2,1.5,11.1,26.7,3,55.7c-6.9,24.7,11,32,21.2,24.1
        C31.3,74.3,41,54,41,54h26.1h26.1c0,0,9.7,20.3,16.8,25.8C120.2,87.6,138,80.4,131.2,55.7z"/>
    <line class="st1" x1="37.7" y1="14.8" x2="37.7" y2="37.1"/>
    <line class="st1" x1="26.5" y1="25.9" x2="48.9" y2="25.9"/>
    <path class="st2" d="M107.9,27.1c-0.6,0-1.1-0.5-1.1-1.1s0.5-1.1,1.1-1.1s1.1,0.5,1.1,1.1S108.5,27.1,107.9,27.1z"/>
    <path class="st2" d="M86,27.1c-0.6,0-1.1-0.5-1.1-1.1s0.5-1.1,1.1-1.1s1.1,0.5,1.1,1.1S86.6,27.1,86,27.1z"/>
    <path class="st2" d="M98.1,15c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1s0.5-1.1,1.1-1.1C97.6,13.9,98.1,14.4,98.1,15z"/>
    <path class="st2" d="M98.1,36.9c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1
        C97.6,35.8,98.1,36.3,98.1,36.9z"/>
</g>
</svg>
</div>
<span>  Project Ares is gamified with scores, XP, badges, and more.</span>
</OnVisible>
<OnVisible  >
<div className="icon">
<svg id="bg" viewBox="-100 -100 200 200"  
   >
 
 
<path class="st0" d="M30.9,-39.5C34.4,-34,27.5,-18.8,28.4,-6.1C29.4,6.6,38.1,16.8,36.3,22C34.6,27.3,22.3,27.5,9.9,35.7C-2.5,43.9,-15.1,60.1,-20.3,57.5C-25.5,54.9,-23.2,33.5,-24.5,19.7C-25.8,6,-30.6,-0.1,-36.6,-13.5C-42.6,-26.8,-49.8,-47.3,-43.9,-52.4C-38,-57.5,-19,-47.1,-2.6,-44C13.7,-40.9,27.5,-45,30.9,-39.5Z"/>
</svg>



<svg  className="chat" viewBox="0 0 113.6 89.5" >
 
<g>
    <path class="st0" d="M9.8,1.5h63.6c4.6,0,8.3,3.7,8.3,8.3v38.7c0,4.6-3.7,8.3-8.3,8.3H37.4L25.8,72.3c-1.6,2.1-5,1-5-1.7V56.8H9.8
        c-4.6,0-8.3-3.7-8.3-8.3V9.8C1.5,5.2,5.2,1.5,9.8,1.5z"/>
    <path class="st0" d="M48.5,62.3v2.8c0,4.6,3.7,8.3,8.3,8.3h22.1L90.6,87c1.7,1.9,4.9,0.8,4.9-1.8V73.4h8.3c4.6,0,8.3-3.7,8.3-8.3
        V26.4c0-4.6-3.7-8.3-8.3-8.3H87.2"/>
</g>
</svg>



 

</div>
<span>  Chat with other players.</span>
</OnVisible  >
   <OnVisible  >
<div className="icon">
<svg id="bg" viewBox="-100 -100 200 200"  
   >
 
 
<path class="st0" d="M30.9,-39.5C34.4,-34,27.5,-18.8,28.4,-6.1C29.4,6.6,38.1,16.8,36.3,22C34.6,27.3,22.3,27.5,9.9,35.7C-2.5,43.9,-15.1,60.1,-20.3,57.5C-25.5,54.9,-23.2,33.5,-24.5,19.7C-25.8,6,-30.6,-0.1,-36.6,-13.5C-42.6,-26.8,-49.8,-47.3,-43.9,-52.4C-38,-57.5,-19,-47.1,-2.6,-44C13.7,-40.9,27.5,-45,30.9,-39.5Z"/>
</svg>
<svg className="hands" viewBox="0 0 98.5 99.9"  >
 
<g>
    <path class="st0" d="M47,64.7L32.3,50c-1.6-1.6-1.5-4.4,0.1-6l2.8-2.8"/>
    <path class="st0" d="M58.8,52.9L39.7,33.8c-1.6-1.6-4.2-1.7-5.8-0.1l0,0c-1.6,1.6-1.7,4.3,0,5.9l19.1,19.1"/>
    <path class="st0" d="M66.1,89.6l-4.4-4.4c-2.6-2.6-8.4-2.6-11.7-5.9L32.3,61.7c-1.6-1.6-1.5-4.4,0.1-6l2.8-2.8"/>
    <path class="st0" d="M66.1,48.5C65.3,47.6,50,32.3,50,32.3c-1.6-1.6-4.1-1.7-5.8-0.1l-3.1,3.1"/>
    <path class="st0" d="M88.2,67.6l-4.4-4.4c-2.5-2.5-3.3-5.3-3.9-8.6c-0.9-4.7-3.1-7.2-4.9-9.1s-3.8-3.8-7.3-7.3
        c-2.2-2.2-4.4-1.5-5.9,0l-2.9,2.9"/>
    <polyline class="st0" points="72,98.4 64.7,91.1 89.6,66.1 97,73.5     "/>
    <path class="st0" d="M10.3,33.8l4.4,4.4c2.6,2.6,2.6,8.4,5.9,11.7l5.9,5.9"/>
    <path class="st0" d="M32.3,11.8l4.4,4.4c2.5,2.5,5.3,3.3,8.6,3.9c4.7,0.9,7.2,3.1,9.1,4.9s3.8,3.8,7.3,7.3"/>
    <polyline class="st0" points="1.5,27.9 8.8,35.3 33.8,10.3 26.5,3     "/>
    <path class="st0" d="M32.3,88.2l4.4-4.4c1.8-1.8,5.2-2.3,8.2-3.6"/>
    <path class="st0" d="M10.3,66.1l4.4-4.4c2.3-2.3,3.2-5,3.8-8"/>
    <polyline class="st0" points="26.5,97 33.8,89.6 8.8,64.7 1.5,72     "/>
    <path class="st0" d="M88.2,32.3l-4.4,4.4c-1.8,1.8-2.3,5.2-3.6,8.2"/>
    <path class="st0" d="M66.1,10.3l-4.4,4.4c-2.4,2.4-5,3.2-8,3.8"/>
    <polyline class="st0" points="97,26.5 89.6,33.8 64.7,8.8 72,1.5     "/>
</g>
</svg>
</div>
<span>    Build community for support, help, or the competitive vibe.</span>
</OnVisible  >

</div>
         
        <div className="last">
      <div className="logo-wrapper"><img alt="Project Ares Logo" src={pAIcon} /><h4>can help you prepare!</h4></div>   <ul>
            <li>
            
             It is designed to support progressive learning
            </li> 
            <li>Start wherever you need to and build up skill on skill</li>
            <li>
             
              There are foundation cyber security learning games (yes, games!)
            </li>
               <li>
             
            Move up by applying those concepts in realistic cyber scenario activities
            </li>
          </ul>
          <div className='cta-wrapper'>
            <div><h4>Ready to get started?  </h4>
              <p>
 
 Learn more about Project Ares for individual learning </p> </div> <a href="#learn-store"> <button name="Get Started" className="flat-button">Get Started Now</button></a>
          </div>
          </div>
      </div>
    )
  }
}

export default LearnInfo
